import { Reveal, Eyebrow } from "./Motion";

const CIRCLE_IMG =
  "https://images.unsplash.com/photo-1602191540222-dc95128f1fe6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGJyZWF0aHdvcmslMjBjaXJjbGUlMjB3ZWxsbmVzcyUyMG1vdmVtZW50JTIwam91cm5hbGluZyUyMGFydHxlbnwwfHx8d2hpdGV8MTc5MTgxNjQ4Nnww&ixlib=rb-4.1.0&q=85";

export const About = () => (
  <section id="about" className="py-20 lg:py-32" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 sm:px-8 lg:grid-cols-2 lg:px-12">
      <Reveal className="order-2 lg:order-1">
        <div className="relative">
          <div className="absolute -inset-5 -rotate-2 rounded-[36px] bg-[#F4E3E0]" />
          <img
            src={CIRCLE_IMG}
            alt="A women's wellness circle in soft morning light"
            className="relative aspect-[5/4] w-full rounded-[28px] border border-[#D9C3A3]/60 object-cover shadow-xl shadow-[#262320]/10"
            data-testid="about-image"
          />
        </div>
      </Reveal>
      <div className="order-1 lg:order-2">
        <Reveal>
          <Eyebrow>About the workshop</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-light tracking-tight text-[#262320] sm:text-4xl lg:text-5xl">
            A soft morning to come home to yourself
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 text-base leading-relaxed text-[#6E6862]">
            This is a gentle, held space for women to slow down. Over one unhurried morning together online, we move
            through breath, body, colour and words — no experience needed, nothing to perform, nowhere else to be.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#6E6862]">
            You will leave with a quieter nervous system, a few honest pages in your journal, a piece of art that is
            entirely yours, and the feeling of having been truly present with yourself and other women.
          </p>
        </Reveal>
        <Reveal delay={0.16} className="mt-10 rounded-[28px] border border-[#D9C3A3]/60 bg-white/70 p-8 lg:p-10" >
          <h3 className="font-serif text-2xl font-light text-[#262320]">Why I Created Beyond the Pain</h3>
          <div className="mt-5 space-y-4 text-sm leading-relaxed text-[#6E6862]" data-testid="about-why-created">
            <p>
              Living with endometriosis can sometimes feel like your life revolves around pain, appointments, symptoms,
              and the constant effort to keep going. In the process, we may forget that we are more than our diagnosis.
            </p>
            <p>
              I created Beyond the Pain: A Creative Healing Circle as a space for women living with endometriosis to
              pause, breathe, express themselves, and connect with others who may understand parts of their journey.
            </p>
            <p>
              Through gentle breathwork, mindful movement, expressive art, and reflective journaling, we will explore
              ways to acknowledge our emotions, listen to our bodies, and create moments of care for ourselves.
            </p>
            <p>
              This is not about forcing positivity, fixing your body, or pretending that pain doesn't exist. It's about
              making room for the parts of you that may get lost in the experience of chronic illness.
            </p>
            <p>
              You don't need any artistic experience or prior knowledge of breathwork. Just bring yourself, an open
              mind, and a willingness to explore at your own pace.
            </p>
            <p>
              My intention is to create a compassionate, non-judgmental space where you can feel heard, express what
              words cannot always capture, and experience the comfort of shared understanding.
            </p>
            <p className="font-serif text-base italic text-[#5E7D6A]">
              Because you are more than your pain. And you deserve spaces where you can simply be yourself. I look
              forward to holding this space with you.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2} className="mt-9 grid grid-cols-3 gap-4">
          {[
            ["4", "nurturing practices"],
            ["1", "intimate circle"],
            ["0", "experience needed"],
          ].map(([num, label]) => (
            <div key={label} className="rounded-2xl border border-[#D9C3A3]/50 bg-white/70 p-5 text-center">
              <p className="font-serif text-3xl text-[#5E7D6A]">{num}</p>
              <p className="mt-1 text-xs text-[#6E6862]">{label}</p>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);
